exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2YTIEpuKIEf7Dn{padding-top:12px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;line-height:20px}._2YTIEpuKIEf7Dn a{color:#172b4d}", ""]);

// exports
exports.locals = {
	"whiteBox": "_2YTIEpuKIEf7Dn"
};